import { NgModule } from '@angular/core';
import { CastToFormArrayPipe } from './cast-to-form-array.pipe';
import { CastToFormGroupPipe } from './cast-to-form-group.pipe';

@NgModule({
  declarations: [
    CastToFormArrayPipe,
    CastToFormGroupPipe
  ],
  exports: [
    CastToFormArrayPipe,
    CastToFormGroupPipe
  ]
})
export class CastToFormArrayModule { }
